export default __webpack_public_path__ + "static/char-v-53-ja-99c5abe9867435aa5f00bab0a379eee3.mp4";